import Banner from '@/components/Banner';
import Chapters, { Chapter } from '@/components/Chapters';
import ImageGallery from '@/components/ImageGallery';
import { Reveal } from '@/components/Reveal';
import ShareDialog from '@/components/ShareDialog';
import Typography from '@/components/ui/typography';
import Band from '@/Layouts/Band';
import SectionLayout from '@/Layouts/SectionLayout';
import { siteStats } from '@/lib/siteStats';

/*
 * The three paragraphs were previously headless — image beside prose, three
 * times, with nothing to scan. The descriptions are the original copy verbatim;
 * the taglines and titles are new, so the page has headings a reader (and a
 * crawler) can navigate by.
 */
const chapters: Chapter[] = [
  {
    tagline: 'In print and on air',
    title: 'Headlines, airwaves and screens',
    description:
      'Imagine the headlines adorning the pages of prestigious publications, the reverberating voices gracing the airwaves of influential radio stations, and the captivating visuals capturing hearts on widely followed YouTube channels. Samuthrika Academy not only claims its place under the sun but illuminates the path to excellence.',
  },
  {
    tagline: `${siteStats.years} years of dedication`,
    title: 'Visionary stewardship',
    description: `Rtn Thamizhachi Priya Govindaraj's visionary stewardship serves as the cornerstone in this saga of triumph. Over ${siteStats.years} years of unwavering dedication, her leadership acts as the driving force propelling the academy to unprecedented heights.`,
  },
  {
    tagline: 'A legacy in the making',
    title: 'The spotlight beckons',
    description:
      "In a realm where recognition holds sway, Samuthrika Academy stands tall as a testament to innovation, dedication, and the relentless pursuit of greatness. To witness this journey is not just awe-inspiring; it's an invitation to partake in a legacy in the making.",
  },
];

const Recognition = ({ images }: { images: string[] }) => {
  const urls = images.map((image) => `/storage/${image}`);

  const chapterImages = urls.slice(1, chapters.length + 1);
  const galleryImages = urls.slice(chapters.length + 1);

  return (
    <>
      <Banner
        image={urls[0]}
        alt="Samuthrika Academy featured in the press"
        tagline="Saga of triumph"
        title="Recognitions"
        description="Acclaim from newspapers and magazines, echoes on influential radio waves, and admiration on popular YouTube screens — all of it pointing at one academy in Trichy."
      >
        <ShareDialog
          url={window.location.href}
          title="Recognitions - Samuthrika Academy"
          content="Amidst the clamor of acclaim from esteemed newspapers and magazines, resonant echoes on influential radio waves, and the glow of admiration on popular YouTube screens, stands the illustrious Samuthrika Academy."
        />
      </Banner>

      <Band tone="raised" pattern="lattice">
        <SectionLayout space="lg">
          <Chapters chapters={chapters} images={chapterImages} />
        </SectionLayout>
      </Band>

      {galleryImages.length > 0 && (
        <Band tone="raised" seam>
          <SectionLayout space="lg">
            <Reveal className="flex flex-col gap-3">
              <Typography.Eyebrow>In the press</Typography.Eyebrow>
              <Typography.Display2 className="text-2xl md:text-3xl lg:text-4xl">
                Coverage and cuttings
              </Typography.Display2>
            </Reveal>

            <ImageGallery
              images={galleryImages}
              alt="Press coverage of Samuthrika Academy"
            />
          </SectionLayout>
        </Band>
      )}
    </>
  );
};

export default Recognition;
